import Recorder from 'recorder-core'
import 'recorder-core/src/engine/wav'
import 'recorder-core/src/engine/pcm'
import 'recorder-core/src/extensions/waveview'
import 'recorder-core/src/extensions/frequency.histogram.view'
import 'recorder-core/src/extensions/lib.fft'
import { ElMessage } from 'element-plus'
Recorder.TrafficImgUrl = '' //关闭图片统计
import { Base64 } from 'js-base64'
import type { RecognitionResult } from './mp3-record'
import { baseHeaders } from './http'
import { isChina } from './location'
import { clearLocalStorageKeeping } from './tool'
export class PcmRecord {
  testSampleRate = 16000
  testBitRate = 16 //本例子只支持16位pcm，不支持其他值
  SendFrameSize = 1280 //每次发送指定二进制数据长度的数据帧
  send_chunk: any
  send_pcmSampleRate: any
  send_pcmBuffer: any
  send_lastFrame: any
  rec: any
  rec2: any
  clearBufferIdx = 0
  processTime = 0
  mergeFrames: Int16Array[] = [] //存储每次发送的数据段,后续合成音频所需
  powerLevelStatus: 0 | 1 = 0
  wave: any = null
  constructor() {
    this.initRec()
  }
  initRec() {
    this.rec2 = this.rec = Recorder({
      type: 'unknown', //这里特意使用unknown格式，方便清理内存
      onProcess: (
        buffers: Int16Array | any[],
        powerLevel: number,
        bufferDuration: number,
        bufferSampleRate: number,
        newBufferIdx: number
      ) => {
        this.wave && this.wave.input(buffers[buffers.length - 1], powerLevel, bufferSampleRate)

        if (powerLevel !== 0) {
          this.powerLevelStatus = 1
        }
        this.processTime = Date.now()
        //实时释放清理内存，用于支持长时间录音；在指定了有效的type时，编码器内部可能还会有其他缓冲，必须同时提供takeoffEncodeChunk才能清理内存，否则type需要提供unknown格式来阻止编码器内部缓冲
        //这里进行了延迟操作（必须要的操作），只清理上次到现在之前的buffer，新的还未推入编码器进行编码需保留
        //if(this.clearBufferIdx>newBufferIdx){ this.clearBufferIdx=0 } //变量改到this里面时，重新录音了，这样写可以重置this环境
        for (var i = this.clearBufferIdx; i < newBufferIdx; i++) {
          buffers[i] = null
        }
        this.clearBufferIdx = newBufferIdx
        //【关键代码】推入实时处理
        this.RealTimeSendTry(buffers, bufferSampleRate, false)
      },
      audioTrackSet: {
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false
      }
    })
  }
  recStop() {
    if (!this.rec2) return console.log('未开始录音', 1)
    this.rec2.watchDogTimer = 0 //停止监控onProcess超时
    this.rec2.close() //直接close掉即可，这个例子不需要获得最终的音频文件。unknown、wav等不支持实时编码的格式无法调用stop，因为onProcess里面清理掉了内存数据
    this.RealTimeSendTry([], 0, true) //最后一次发送
    this.rec2 = this.rec = null
  }
  RealTimeSendTry(buffers: Int16Array | any[], bufferSampleRate: number, isClose: boolean) {
    //提取出新的pcm数据
    var pcm = new Int16Array(0)
    if (buffers.length > 0) {
      //【关键代码】借用SampleData函数进行数据的连续处理，采样率转换是顺带的，得到新的pcm数据
      var chunk = Recorder.SampleData(
        buffers,
        bufferSampleRate,
        this.testSampleRate,
        this.send_chunk
      )
      this.send_chunk = chunk

      pcm = chunk.data //此时的pcm就是原始的音频16位pcm数据（小端LE），直接保存即为16位pcm文件、加个wav头即为wav文件、丢给mp3编码器转一下码即为mp3文件
      this.send_pcmSampleRate = chunk.sampleRate //实际转换后的采样率，如果testSampleRate值比录音数据的采样率大，将会使用录音数据的采样率
    }

    //没有指定固定的帧大小，直接把pcm发送出去即可
    if (!this.SendFrameSize) {
      this.TransferUpload(pcm, isClose)
      return
    }

    //先将新的pcm写入缓冲，再按固定大小切分后发送
    var pcmBuffer = this.send_pcmBuffer
    var tmp = new Int16Array(pcmBuffer.length + pcm.length)
    tmp.set(pcmBuffer, 0)
    tmp.set(pcm, pcmBuffer.length)
    pcmBuffer = tmp

    //循环切分出固定长度的数据帧
    var chunkSize = this.SendFrameSize / (this.testBitRate / 8)
    while (true) {
      //切分出固定长度的一帧数据
      if (pcmBuffer.length >= chunkSize) {
        var frame = new Int16Array(pcmBuffer.subarray(0, chunkSize))
        pcmBuffer = new Int16Array(pcmBuffer.subarray(chunkSize))
        var closeVal = false
        if (isClose && pcmBuffer.length == 0) {
          closeVal = true //已关闭录音，且没有剩余要发送的数据了
        }
        this.TransferUpload(frame, closeVal)
        if (!closeVal) continue //循环切分剩余数据
      } else if (isClose) {
        //已关闭录音，但此时结尾剩余的数据不够一帧长度，结尾补0凑够一帧即可，或者直接丢弃结尾的这点数据
        var frame = new Int16Array(chunkSize)
        frame.set(pcmBuffer)
        pcmBuffer = new Int16Array(0)
        this.TransferUpload(frame, true)
      }
      break
    }
    //剩余数据存回去，留给下次发送
    this.send_pcmBuffer = pcmBuffer
  }
  TransferUpload(pcmFrame: Int16Array, isClose: boolean) {
    if (isClose && pcmFrame.length == 0) {
      //最后一帧数据，在没有指定固定的帧大小时，因为不是从onProcess调用的，pcmFrame的长度为0没有数据。可以修改成复杂一点的逻辑：停止录音时不做任何处理，等待下一次onProcess回调时再调用实际的停止录音，这样pcm就一直数据了；或者延迟一帧的发送，isClose时取延迟的这帧作为最后一帧
      //这里使用简单的逻辑：直接生成一帧静默的pcm（全0），使用上一帧的长度或50ms长度
      //return; //如果不需要处理最后一帧数据，直接return不做任何处理
      var len = this.send_lastFrame
        ? this.send_lastFrame.length
        : Math.round((this.send_pcmSampleRate / 1000) * 50)
      pcmFrame = new Int16Array(len)
    }
    this.send_lastFrame = pcmFrame
    this.mergeFrames.push(pcmFrame)
    //*********发送方式一：Base64文本发送***************
    var str = '',
      bytes = new Uint8Array(pcmFrame.buffer)
    for (var i = 0, L = bytes.length; i < L; i++) str += String.fromCharCode(bytes[i])
    var base64 = btoa(str)
    this.onSendBase64(base64, isClose)
  }
  onSendBase64(_base64: string, _isClose: boolean) {}
  /**
   * 初始化,每次录制都需要初始化一次
   */
  RealTimeSendReset() {
    this.send_pcmBuffer = new Int16Array(0)
    this.send_pcmSampleRate = this.testSampleRate
    this.send_chunk = null
    this.send_lastFrame = null
    this.mergeFrames = []
  }
  /**
   *
   * @returns
   */
  MergeFramesToAudio(): Promise<RecAudioInfo> {
    return new Promise((resolve, reject) => {
      if (!this.mergeFrames) {
        reject('未勾选合并成一个完整pcm，不测试合并成完整pcm文件')
      }
      var size = 0
      for (var i = 0; i < this.mergeFrames.length; i++) size += this.mergeFrames[i].length
      if (size == 0) {
        reject('未录制得到pcm数据帧，不测试合并成完整pcm文件')
      }
      var pcm = new Int16Array(size)
      for (var i = 0, offset = 0; i < this.mergeFrames.length; i++) {
        pcm.set(this.mergeFrames[i], offset)
        offset += this.mergeFrames[i].length
      }
      var blob = new Blob([pcm.buffer], { type: 'audio/pcm' })
      Recorder.pcm2wav(
        {
          sampleRate: this.send_pcmSampleRate,
          bitRate: this.testBitRate,
          blob: blob
        },
        (wavBlob: Blob, duration: number) => {
          resolve({
            duration,
            blob: wavBlob,
            audioUrl: ''
          })
        }
      )
    })
  }
}
Recorder.CLog = function (error: any) {
  console.log(error, '-------Recorder 日志信息------')
}
export class WavRecord extends PcmRecord {
  isDing = false
  dingMp3: HTMLAudioElement = new Audio(new URL(`@/assets/mp3/ding.mp3`, import.meta.url).href)
  controller = new AbortController()
  iseWS: WebSocket | undefined
  businessText: string | undefined //评测文本
  /**是正在录制 */
  isRecording = false
  overTimer = 0
  recognitionResult: RecognitionResult | undefined
  onStart: () => void = () => {}
  onStop: () => void = () => {}
  onScore: (result?: string) => void = () => {}
  onError: (data?: any) => void = () => {}
  constructor() {
    super()
    this.onSendBase64 = (base64, isClose) => {
      if (isClose) {
        this.sendXunFei(2, base64 || '', true)
      } else {
        this.sendXunFei(2, base64, false)
      }
    }
  }
  /**
   * 开始录制
   * @param businessText 评测文本
   * @param isEva 是否为评测
   * @returns
   */
  start(data: startData) {
    if (this.isRecording) return
    if (data.waveView && Recorder.WaveView) {
      this.wave = Recorder.FrequencyHistogramView({
        elem: data.waveView,
        keep: true,
        lineCount: 50,
        position: 0,
        minHeight: 1,
        stripeEnable: false,
        linear: [0, '#51a4c4', 1, '#51a4c4']
      })
      this.wave.input([])
    }
    data.onStart && (this.onStart = data.onStart)
    data.onStop && (this.onStop = data.onStop)
    data.onScore && (this.onScore = data.onScore)
    data.onError && (this.onError = data.onError)
    this.businessText = data.businessText
    stopAllAudio()
    this.initRec()
    if (!Recorder.IsOpen()) {
      this.rec.open(
        () => {
          this.rec_start()
        },
        (err: string) => {
          ElMessage({
            showClose: true,
            message: err,
            type: 'error',
            duration: 3000
          })
          this.onStop()
        }
      )
    } else {
      this.rec_start()
    }
    this.RealTimeSendReset()
  }
  /**
   * 开始录制音频(调用此方法前,请确保已经授权录音成功)
   */
  rec_start() {
    this.controller = new AbortController()
    if (this.businessText) {
      this.connectWebSocket()
        .then((_res) => {
          if (this.rec) {
            this.sendXunFei(1, '', false)
            this.rec.start() //开始录制
            this.onStart()
            this.isRecording = true
          } else {
            this.cancelRecording()
          }
        })
        .catch((err) => {
          if (typeof err === 'string') {
            if (err.indexOf('aborted') !== -1) {
              ElMessage({
                showClose: true,
                message: err || '获取ws连接失败',
                type: 'error',
                duration: 3000
              })
            }
          }
        })
    } else {
      this.rec.start() //开始录制
      this.onStart()
      this.isRecording = true
    }
  }
  /**结束录制 */
  end(): Promise<WavRecord> {
    if (!this.rec && !this.rec2) {
      return Promise.resolve(this)
    }
    if (this.powerLevelStatus === 0) {
      this.cancelRecording(() => {
        this.onError({ code: 1001 })
      })
      return Promise.resolve(this)
    }
    return new Promise((resolve) => {
      this.recStop()
      this.onStop()
      this.isRecording = false
      resolve(this)
    })
  }
  /**
   * 取消录音不放回结果
   */
  cancelRecording(callback?: () => void) {
    if (this.rec) {
      this.rec.close(() => {
        this.onStop()
        this.isRecording = false
        callback && callback()
      })
    } else {
      this.onStop()
      this.isRecording = false
      callback && callback()
    }

    this.controller.abort()

    if (this.iseWS) {
      // 连接成功
      this.iseWS.onopen = () => {}
      // 收到消息
      this.iseWS.onmessage = (_e) => {}
      // 连接失败
      this.iseWS.onerror = () => {}
      // 连接关闭
      this.iseWS.onclose = () => {}
      this.iseWS = undefined
    }
  }

  /**
   * 取讯飞评测地址
   * @returns url地址
   */
  getXunfAuthUrl() {
    var host = config.host
    var ctrler = config.controllers
    var url = 'wss://'.concat(host).concat(ctrler)
    const formDataObj = new FormData()
    formDataObj.append('hostUrl', url)
    return new Promise<string>((resolve, reject) => {
      fetch('/api/xunf/getAuthUrl', {
        headers: {
          token: localStorage.getItem('token') || '',
          ...baseHeaders
        },
        method: 'post',
        body: formDataObj,
        signal: this.controller.signal
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.code === 0) {
            resolve(res.data as string) //返回url地址
          } else {
            // TOKEN失效
            if ([10006, 100017, 100016].includes(res.data)) {
              // 清空token,刷新页面
              if (localStorage.getItem('token')) {
                clearLocalStorageKeeping()
                ElMessage.error({
                  offset: 120,
                  message: res.msg,
                  duration: 3000
                })
                setTimeout(() => {
                  location.reload()
                }, 3000)
              }
              return
            }
            reject(res.msg)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  connectWebSocket() {
    clearTimeout(this.overTimer)
    return new Promise((resolve, reject) => {
      this.getXunfAuthUrl()
        .then((res) => {
          this.iseWS = new WebSocket(res)
          this.overTimer = window.setTimeout(() => {
            reject('连接测评服务器超时')
            this.iseWS?.close()
          }, 10000)
          // 连接成功
          this.iseWS.onopen = () => {
            clearTimeout(this.overTimer)
            resolve(this.iseWS)
          }
          // 收到消息
          this.iseWS.onmessage = (e) => {
            this.onXunMag(e.data as string)
          }
          // 连接失败
          this.iseWS.onerror = () => {
            clearTimeout(this.overTimer)
            this.end()
          }
          // 连接关闭
          this.iseWS.onclose = () => {
            clearTimeout(this.overTimer)
            this.end()
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  sendXunFei(number: number, base64: string, isClose: boolean) {
    // 处于断开或关闭时不发送
    let payload = {}
    if (number === 1) {
      payload = JSON.stringify({
        common: {
          app_id: config.appId
        },
        business: {
          category: 'read_sentence',
          rstcd: 'utf8',
          group: 'pupil',
          sub: 'ise',
          ent: config.ent,
          tte: 'utf-8',
          cmd: 'ssb',
          auf: 'audio/L16;rate=16000',
          aus: 1,
          aue: 'raw',
          text:
            '\uFEFF' +
            (this.businessText || '')
              .replace(/[\u00a0\u3000]/g, ' ')
              .replace(/[@#$%&*{}]/g, '')
              .trim()
        },
        data: {
          status: 0
        }
      })
    } else {
      payload = JSON.stringify({
        business: {
          cmd: 'auw',
          aus: isClose ? 4 : 2,
          aue: 'raw'
        },
        data: {
          status: isClose ? 2 : 1,
          encoding: 'raw',
          data_type: 1,
          data: base64 || ''
        }
      })
    }
    if (this.iseWS && this.iseWS.readyState === this.iseWS.OPEN) {
      this.iseWS && this.iseWS.send(payload as string)
    }
  }
  // 分析ws评测结果
  onXunMag(resultData: string) {
    // 识别结束
    let jsonData = JSON.parse(resultData)
    if (jsonData.data && jsonData.data.data) {
      var data = Base64.decode(jsonData.data.data)
      this.onScore(data)
    }
    if (jsonData.code === 0 && jsonData.data.status === 2) {
      this.iseWS && this.iseWS.close()
      this.end()
    }
    if (jsonData.code !== 0) {
      this.cancelRecording(() => {
        this.onError()
      })
      if (jsonData.code === 48195) {
        ElMessage({
          showClose: true,
          message: '试题格式错误-' + jsonData.code,
          type: 'error',
          duration: 3000
        })
      } else {
        ElMessage({
          showClose: true,
          message: '录音时间过短',
          type: 'error',
          duration: 3000
        })
      }
    }
  }
}

export const ytRecord = new WavRecord()

export interface startData {
  businessText?: string
  questionsId?: string | number
  waveView?: HTMLDivElement
  onStart?: () => void
  onStop?: () => void
  onScore?: (result?: string, recognitionResult?: RecognitionResult) => void
  onError?: (data?: { code: number }) => void
  onBaiduRecognition?: () => void
}
/**
 * 暂停所有音频
 * @param dom 排除当前音频Dom
 */
export function stopAllAudio(dom?: HTMLAudioElement) {
  const _audio = dom
  const audios = [...document.querySelectorAll('audio'), ...document.querySelectorAll('video')]
  audios.forEach((item) => {
    if (item !== _audio) {
      item.pause()
    }
  })
}

/**
 * 判断是否海外环境（与 oss.ts 中逻辑一致）
 * 时区非 UTC+8、域名为 pte-api.ytaxx.com/www-singapore.ytaxx.com，
 * 或 IP 属地（App.vue provide 的 isChina 共享值）非中国，均视为海外
 */
const isOverseas = (): boolean => {
  if (['pte-api.ytaxx.com', 'www-singapore.ytaxx.com'].includes(window.location.host)) {
    return true
  }
  const timeZone = -new Date().getTimezoneOffset() / 60
  return timeZone !== 8 || !isChina.value
}

// 判断是否为火狐浏览器(解决火狐浏览器部分版本无法连接上讯飞服务器)
const isFirefox = (): boolean => {
  return typeof (window as any).InstallTrigger !== 'undefined'
}

// 使用 getter 惰性求值，确保在录音开始建立连接时能读到最新的 IP 属地判断结果
export const config = {
  ent: 'en_vip',
  get appId() {
    return isOverseas() ? 'g9b048e8' : '5b9f9a70'
  },
  get host() {
    if (isOverseas()) return 'ise-api-sg.xf-yun.com'
    return isFirefox() ? 'ise-api.xf-yun.com' : 'ise-api.xfyun.cn'
  },
  get controllers() {
    return isOverseas() ? '/v2/ise' : '/v2/open-ise'
  }
}
export interface RecAudioInfo {
  audioUrl: string
  duration: number
  blob: Blob
}
